import { render, staticRenderFns } from "./UiMetadataSource.vue?vue&type=template&id=bab447f4"
import script from "./UiMetadataSource.vue?vue&type=script&lang=js"
export * from "./UiMetadataSource.vue?vue&type=script&lang=js"
import style0 from "./UiMetadataSource.vue?vue&type=style&index=0&id=bab447f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports